// Strefy Matrix na festiwalach — blokada niepełnoletnich (<18 lat) + offline zapis leadów (IndexedDB).
// Slugi trzymamy małymi literami; porównanie jest case-insensitive, bo np. slug MNY ma wielkie litery
// (strefa-matrix-festiwal-MNY-music-stories) i trafia tu wprost z parametru trasy.
export const MATRIX_FESTIVAL_SLUGS: readonly string[] = [
  'strefa-matrix-festiwal-ekipy',
  'strefa-matrix-festiwal-mny-music-stories',
  'strefa-matrix-festiwal-top-of-the-top',
];

export const isMatrixFestivalSlug = (slug: string | null | undefined): boolean =>
  !!slug && MATRIX_FESTIVAL_SLUGS.includes(slug.toLowerCase());
